import { InterestingList } from './InterestingList'
import { InterestingCreate } from './InterestingCreate'
import { InterestingEdit } from './InterestingEdit'
import { InterestingShow } from './InterestingShow'

export { InterestingList, InterestingCreate, InterestingEdit, InterestingShow }


// WEBPACK FOOTER //
// ./src/components/interesting/index.js